import { render } from "./SafetyInformationUpdate.vue?vue&type=template&id=26463f3e"
import script from "./SafetyInformationUpdate.vue?vue&type=script&lang=js"
export * from "./SafetyInformationUpdate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__